import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ExtensionDetail from "@/pages/ExtensionDetail";
import Confirmation from "@/pages/Confirmation";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import TCGManagement from "@/pages/admin/TCGManagement";
import ExtensionList from "@/pages/admin/ExtensionList";
import ExtensionAdmin from "@/pages/admin/ExtensionAdmin";
import Navbar from "@/components/Navbar";
import Wishlist from "@/pages/Wishlist";
import Series from "@/pages/Series";
import SeriesList from "@/pages/admin/SeriesList";
import SeriesAdmin from "@/pages/admin/SeriesAdmin";
import Account from "@/pages/admin/Account";
import Orders from "@/pages/admin/Orders";
import EmailTemplates from "@/pages/admin/EmailTemplates";
import ResetPassword from "@/pages/admin/ResetPassword";
import AllocationDashboard from "@/pages/admin/AllocationDashboard";
import Stock from "@/pages/admin/Stock";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<><Navbar /><Home /></>} />
          <Route path="/catalogue" element={<><Navbar /><Catalog /></>} />
          <Route path="/extension/:id" element={<><Navbar /><ExtensionDetail /></>} />
          <Route path="/confirmation/:id" element={<><Navbar /><Confirmation /></>} />
          <Route path="/wishlist" element={<><Navbar /><Wishlist /></>} />
          <Route path="/series" element={<><Navbar /><Series /></>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reinitialiser" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="tcg" element={<TCGManagement />} />
            <Route path="extensions" element={<ExtensionList />} />
            <Route path="extensions/:id" element={<ExtensionAdmin />} />
            <Route path="extensions/:id/allocations" element={<AllocationDashboard />} />
            <Route path="stock" element={<Stock />} />
            <Route path="series" element={<SeriesList />} />
            <Route path="series/:id" element={<SeriesAdmin />} />
            <Route path="compte" element={<Account />} />
            <Route path="commandes" element={<Orders />} />
            <Route path="emails" element={<EmailTemplates />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
